<template>
  <v-container py-1>
    <div class="text-left">
      Below is a list of the programs we offer. Each program is designed to provide unique benefits and cater to different needs. 
      To learn more about a specific program, simply expand the section to view its full details, including descriptions and key features.
    </div>

    <div v-for="(products, productTypeName) in groupedProducts" :key="productTypeName">
      <h3 class="text-h5 font-weight-bold mt-4 darkred">{{ productTypeName }}</h3>
      <v-expansion-panels multiple class="mt-2">
        <v-expansion-panel v-for="(product, index) in products" :key="index">
          <v-expansion-panel-header class="text-body-1 charcoal">
            {{ product.ProductName }}
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="product.DescriptionLong" class="text-body-2 secondary--text redbox">
            <div v-html="product.DescriptionLong"></div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    groupedProducts() {
      if (!Array.isArray(this.products)) {
        return {}
      }

      // Filter products that should be displayed
      const filteredProducts = this.products.filter((prod) => prod.IsDisplay === true)

      // Group by ProductType
      return filteredProducts.reduce((groups, product) => {
        const type = product.ProductTypeName || 'Other' // Default category if missing

        if (!groups[type]) {
          groups[type] = []
        }
        groups[type].push(product)

        return groups
      }, {})
    }
  }
}
</script>

<style scoped>
.v-expansion-panels {
    background: transparent !important; /* Removes background */
    box-shadow: none !important; /* Removes any shadow */
    border: none !important; /* Removes any border */
    justify-content: center;
}

/* Removes the top border between panels */
.v-expansion-panel:not(:first-child)::after {
    border-top: none !important; /* Removes the border */
    content: none !important; /* Prevents the element from rendering */
}

/* Ensure panels don't have borders */
.v-expansion-panel {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    margin-bottom: 0px !important; /* Reduce gap between panels */
}

/* Remove border from expanded panels */
.v-expansion-panel--active {
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
}

/* Remove default elevation/shadow */
.v-expansion-panel::before {
    box-shadow: none !important;
    background: transparent !important;
}

/* Remove rounded/bubble effect */
.v-expansion-panel-header {
    font-weight: 400 !important; /* Bold, but adjust color if needed */
    opacity: 0.9; /* Slightly reduce opacity to soften the look */
    border-radius: 0 !important;
    background: transparent !important;
    padding: 8px 8px 8px 4px !important; /* Reduce padding */
    min-height: 32px !important; /* Reduce default height */
}

.v-expansion-panel-content {
  border: 1px solid lightgray;
  border-radius: 6px !important;
  padding: 20px !important; /* Reduce content padding */
}

/* Optional: Adjust padding */
.v-expansion-panel-content__wrap {
    padding: 10px 0 !important; /* Adjust spacing */
}

.theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: rgb(165 29 50) !important;
}
</style>
